import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import DataPortabilityNavigation from 'components/settings/DataPortabilityNavigation';
import DataPortability from 'components/settings/DataPortability';

import { fetchDataPortability } from 'redux/modules/dataPortability';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class DataPortabilityVariant extends Component {
  componentDidMount() {
    const { actions, dataPortability } = this.props;
    if (dataPortability.length === 0) {
      actions.fetchDataPortability({
        triggerLoading: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { loading, history, match } = this.props;
    if (loading > 0
      && nextProps.loading === 0) {
      if (nextProps.dataPortability.length === 0) {
        history.replace('/settings');
      } else if (!nextProps.dataPortability
        .find(item => item.Route === match.params.id)) {
        const firsVariant = nextProps.dataPortability[0].Route;
        history.replace(`/settings/data-portability/${firsVariant}`);
      }
    }
  }

  render() {
    const { dataPortability, loading, match } = this.props;
    const dataPortabilityItem = dataPortability
      .find(item => item.Route === match.params.id);

    return (
      <Layout variant="settings">
        {(loading > 0) ? (
          <Progress />
        ) : (
          <Fragment>
            <Helmet>
              <title>
                {appTitle} {titleSeparator} Data Portability {dataPortabilityItem
                  ? `${titleSeparator} ${dataPortabilityItem.Title}` : ''}
              </title>
            </Helmet>
            <DataPortabilityNavigation dataPortability={dataPortability} />
            <DataPortability
              {...dataPortabilityItem}
            />
          </Fragment>
        )}
      </Layout>
    );
  }
}

DataPortabilityVariant.propTypes = {
  dataPortability: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    Route: PropTypes.string.isRequired,
  })).isRequired,
  loading: PropTypes.number.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    fetchDataPortability: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = store => ({
  dataPortability: store.dataPortability.data,
  loading: store.dataPortability.loading,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchDataPortability }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DataPortabilityVariant);



// WEBPACK FOOTER //
// ./src/pages/settings/DataPortabilityVariant.js